import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Typography } from '@material-ui/core';
import { Trans } from 'react-i18next';

const useStyles = makeStyles(() => ({
  root: {}
}));

function Header({ exhibitor, className, ...rest }) {
  const classes = useStyles();

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Typography
        component="h2"
        gutterBottom
        variant="overline"
      >
        <Trans>frontend.schedule_meeting</Trans>
      </Typography>
      <Typography
        component="h1"
        variant="h3"
      >
        <Trans>frontend.schedule_meeting_with</Trans>{ exhibitor.getName() }
      </Typography>
    </div>
  );
}

Header.propTypes = {
  className: PropTypes.string
};

export default Header;
